var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-flex-direction-row is-justify-content-space-between px-4 py-1",staticStyle:{"border":"thin solid whitesmoke"}},[_c('div',{staticClass:"is-subtitle"},[_vm._v(_vm._s(_vm.title))]),(_vm.href)?_c('a',{attrs:{"href":_vm.href}},[_c('div',[_vm._v(_vm._s(_vm.value))])]):_c('div',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }